<template>
  <div :class="{'flex-column':createFlag, 'app-container':createFlag, 'flex-item':createFlag}">
    <div class="metter1">
      <el-form :model="temp" :rules="rules" ref="temp" label-width="120px" v-if="tabindex==0">
        <el-row :span="24">
          <el-col :span="12">
            <el-form-item size="small" :label="'教官姓名'" prop="name">
              <el-input v-model="temp.name" style="width:280px" disabled></el-input>
            </el-form-item>

            <el-form-item size="small" :label="'身份证号'" prop="idCard">
              <div style="display: flex;">
                <el-input
                  v-model="temp.idCard"
                  style="width:280px;display: inline-block;padding-right:5px"
                  disabled
                ></el-input>
              </div>
            </el-form-item>

            <el-form-item size="small" :label="'所在部门'" prop="curDeptId">
              <TreeSelect
                :key="sid"
                :typeOne="typeOne"
                :parentIdOne="parentIdOne"
                :checkedKeys="defaultCheckedKeys"
                @popoverHide="popoverHide"
                :width="280"
                style="width:280px;"
              ></TreeSelect>
            </el-form-item>

            <el-form-item size="small" prop="sex">
              <label
                slot="label"
                style="color: #606266 !important;font-weight:400 !important"
              >性&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 别</label>
              <el-radio-group v-model="temp.sex" style="width:280px">
                <el-radio :label="true">男</el-radio>
                <el-radio :label="false">女</el-radio>
              </el-radio-group>
            </el-form-item>

            <!-- <el-form-item size="small" :label="'生日'" prop="birthday">
              <el-date-picker
                v-model="temp.birthday"
                type="date"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>-->

            <el-form-item size="small" prop="ethic">
              <label
                slot="label"
                style="color: #606266 !important;font-weight:400 !important"
              >民&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 族</label>
              <el-input v-model="temp.ethic" style="width:280px"></el-input>
            </el-form-item>
            <el-form-item size="small" :label="'工作单位'" prop="unit">
              <el-input v-model="temp.unit" style="width:280px"></el-input>
            </el-form-item>
            <el-form-item size="small" prop="zwmc">
              <label
                slot="label"
                style="color: #606266 !important;font-weight:400 !important"
              >职&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 务</label>
              <el-input v-model="temp.zwmc" style="width:280px"></el-input>
            </el-form-item>
            <el-form-item size="small" :label="'联系电话'" prop="phone">
              <el-input v-model="temp.phone" style="width:280px"></el-input>
            </el-form-item>

            <!-- <el-form-item size="small" :label="'联系电话'" prop="phone">
              <el-input v-model="temp.phone" style="width:280px"></el-input>
            </el-form-item>-->

            <el-form-item size="small" :label="'首页显示'" prop="isHome">
              <el-radio-group v-model="temp.isHome" style="width:280px">
                <el-radio :label="true" disabled>是</el-radio>
                <el-radio :label="false" disabled>否</el-radio>
              </el-radio-group>

              <!-- <span v-if="temp.isHome" style="width:280px">是</span>
              <span v-else style="width:280px">否</span>-->
            </el-form-item>
            <!-- <el-form-item size="small" prop="photo">
              <label
                slot="label"
                style="color: #606266 !important;font-weight:400 !important"
              >头&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 像</label>
              <changerheader
                @chilUpload="chilUpload"
                style="margin-left:50px"
                :imageUrl="temp.photo"
              ></changerheader>
            </el-form-item>-->

            <el-form-item size="small" :label="'个人简介'" prop="introduce">
              <el-input
                type="textarea"
                :rows="10"
                :col="10"
                v-model="temp.introduce"
                style="width:280px"
              ></el-input>
            </el-form-item>

            <!-- <el-form-item size="small" :label="'授课方向'" prop="skill">
              <el-input
                type="textarea"
                :rows="10"
                :col="10"
                v-model="temp.skill"
                style="width:280px"
              ></el-input>
            </el-form-item>-->
          </el-col>

          <el-col :span="12">
            <el-form-item size="small" prop="jzDicId">
              <label
                slot="label"
                style="color: #606266 !important;font-weight:400 !important"
              >警&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 种</label>
              <elSelectc
                style="width:280px"
                :NamespaceId="1"
                :key="sid"
                v-if="ishowselect"
                :typeNames="temp.jzDicName"
                :typeids="temp.jzDicId"
                @selectData="selectDatajzDicId"
              ></elSelectc>
            </el-form-item>

            <el-form-item size="small" prop="jbDicId">
              <label
                slot="label"
                style="color: #606266 !important;font-weight:400 !important"
              >级&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 别</label>

              <el-select
                v-model="jbDicIdList"
                multiple
                placeholder="请选择"
                @change="btnjbDicId"
                style="width:280px"
              >
                <el-option
                  v-for="item in optionsjbDic"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item size="small" :label="'教官类别'" prop="typeDicId">
              <el-select
                v-model="typeDicIdList"
                multiple
                placeholder="请选择"
                @change="btnbaseType"
                style="width:280px"
              >
                <el-option
                  v-for="item in optionsType"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item size="small" :label="'专职/兼职'" prop="isFullTime">
              <el-select v-model="temp.isFullTime" placeholder="请选择" style="width:280px">
                <el-option label="专职" :value="0"></el-option>
                <el-option label="兼职" :value="1"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item size="small" :label="'现任/曾任'" prop="workstatus">
              <el-select v-model="temp.workstatus" placeholder="请选择" style="width:280px">
                <el-option label="现任" :value="0"></el-option>
                <el-option label="曾任" :value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="教官方向" size="small">
              <el-select
                style="width:280px"
                v-model="ziyuanLabel"
                multiple
                filterable
                allow-create
                default-first-option
                placeholder="请选择或者输入标签"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item size="small" prop="levelId">
              <label
                slot="label"
                style="color: #606266 !important;font-weight:400 !important"
              >等&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 级</label>
              <elSelectc
                style="width:280px"
                :NamespaceId="72"
                :key="sid"
                :typeids="temp.levelId"
                @selectData="selectDatalevelId"
              ></elSelectc>
            </el-form-item>

            <el-form-item size="small" :label="'聘用日期'" prop="pinDate">
              <el-date-picker
                v-model="temp.pinDate"
                type="date"
                placeholder="聘用日期"
                value-format="yyyy-MM-dd"
                style="width:280px"
              ></el-date-picker>
            </el-form-item>

            <el-form-item size="small" :label="'解聘日期'">
              <el-date-picker
                style="width:280px"
                v-model="temp.jpDate"
                type="date"
                placeholder="解聘日期"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
            <el-form-item size="small" :label="'授课方向'" prop="skill">
              <el-input
                type="textarea"
                :rows="10"
                :col="10"
                v-model="temp.skill"
                style="width:280px"
              ></el-input>
            </el-form-item>

            <!-- <div class="button" v-if="!handleUpdaterow"> -->
            <div class="button">
              <el-button type="primary" @click="addOrEditData">确认</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <!-- <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="教官信息" name="0">
          <el-form :model="temp" :rules="rules" ref="temp" label-width="100px" v-if="tabindex==0">
            <el-row :span="24">
              <el-col :span="12">
                <el-form-item size="small" :label="'教官姓名'" prop="name">
                  <el-input v-model="temp.name" style="width:220px" disabled></el-input>
                </el-form-item>

                <el-form-item size="small" :label="'身份证'" prop="idCard">
                  <div style="display: flex;">
                    <el-input
                      v-model="temp.idCard"
                      style="width:220px;display: inline-block;padding-right:5px"
                      disabled
                    ></el-input>
                  </div>
                </el-form-item>

                <el-form-item size="small" :label="'所在单位'" prop="curDeptId">
                  <TreeSelect
                    :key="sid"
                    :typeOne="typeOne"
                    :parentIdOne="parentIdOne"
                    :checkedKeys="defaultCheckedKeys"
                    @popoverHide="popoverHide"
                    :width="220"
                  ></TreeSelect>
                </el-form-item>

                <el-form-item size="small" :label="'性别'" prop="sex">
                  <el-radio-group v-model="temp.sex">
                    <el-radio :label="true">男</el-radio>
                    <el-radio :label="false">女</el-radio>
                  </el-radio-group>
                </el-form-item>

                <el-form-item size="small" :label="'生日'" prop="birthday">
                  <el-date-picker
                    v-model="temp.birthday"
                    type="date"
                    placeholder="选择日期"
                    value-format="yyyy-MM-dd"
                  ></el-date-picker>
                </el-form-item>

                <el-form-item size="small" :label="'联系电话'" prop="phone">
                  <el-input v-model="temp.phone" style="width:220px"></el-input>
                </el-form-item>

                <el-form-item size="small" :label="'民族'" prop="ethic">
                  <el-input v-model="temp.ethic" style="width:220px"></el-input>
                </el-form-item>

                <el-form-item size="small" :label="'职务/职级'" prop="zwmc">
                  <el-input v-model="temp.zwmc" style="width:220px"></el-input>
                </el-form-item>

                <el-form-item size="small" :label="'警衔'" prop="ranks">
                  <el-input v-model="temp.ranks" style="width:220px"></el-input>
                </el-form-item>

                <el-form-item size="small" :label="'首页显示'" prop="isHome">
                  <el-radio-group v-model="temp.isHome">
                    <el-radio :label="true">是</el-radio>
                    <el-radio :label="false">否</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item size="small" :label="'头像'" prop="photo">
                  <changerheader
                    @chilUpload="chilUpload"
                    style="margin-left:50px"
                    :imageUrl="temp.photo"
                  ></changerheader>
                </el-form-item>

                <el-form-item size="small" :label="'个人简介'" prop="introduce">
                  <el-input
                    type="textarea"
                    :rows="10"
                    :col="10"
                    v-model="temp.introduce"
                    style="width:250px"
                  ></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item size="small" :label="'专职或兼职'" prop="isFullTime">
                  <el-select v-model="temp.isFullTime" placeholder="请选择">
                    <el-option label="专职" :value="0"></el-option>
                    <el-option label="兼职" :value="1"></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item size="small" :label="'现任或曾任'" prop="workstatus">
                  <el-select v-model="temp.workstatus" placeholder="请选择">
                    <el-option label="现任" :value="0"></el-option>
                    <el-option label="曾任" :value="1"></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item size="small" :label="'警种'" prop="jzDicId">
                  <elSelectc
                    :NamespaceId="1"
                    :key="sid"
                    v-if="ishowselect"
                    :typeNames="temp.jzDicName"
                    :typeids="temp.jzDicId"
                    @selectData="selectDatajzDicId"
                  ></elSelectc>
                </el-form-item>

                <el-form-item size="small" :label="'级别'" prop="jbDicId">
                  <el-select v-model="jbDicIdList" multiple placeholder="请选择" @change="btnjbDicId">
                    <el-option
                      v-for="item in optionsjbDic"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item size="small" :label="'教官类别'" prop="typeDicId">
                  <el-select
                    v-model="typeDicIdList"
                    multiple
                    placeholder="请选择"
                    @change="btnbaseType"
                  >
                    <el-option
                      v-for="item in optionsType"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="教官方向">
                  <el-select
                    v-model="ziyuanLabel"
                    multiple
                    filterable
                    allow-create
                    default-first-option
                    placeholder="请选择或者输入标签"
                  >
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item size="small" :label="'聘用日期'" prop="pinDate">
                  <el-date-picker
                    v-model="temp.pinDate"
                    type="date"
                    placeholder="聘用日期"
                    value-format="yyyy-MM-dd"
                  ></el-date-picker>
                </el-form-item>

                <el-form-item size="small" :label="'解聘日期:'">
                  <el-date-picker
                    v-model="temp.jpDate"
                    type="date"
                    placeholder="解聘日期"
                    value-format="yyyy-MM-dd"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item size="small" :label="'授课方向'" prop="skill">
                  <el-input
                    type="textarea"
                    :rows="10"
                    :col="10"
                    v-model="temp.skill"
                    style="width:315px"
                  ></el-input>
                </el-form-item>

                <div class="button">
                  <el-button type="primary" @click="addOrEditData">确认</el-button>
                </div>
              </el-col>
            </el-row>
          </el-form>
        </el-tab-pane>

        <el-tab-pane label="个人教历" name="1">
          <gerenJL :userId="userId" v-if="tabindex==1" :key="sid"></gerenJL>
        </el-tab-pane>
        <el-tab-pane label="个人训历" name="2">
          <gerenxunLI :userId="userId" v-if="tabindex==2" :key="sid"></gerenxunLI>
        </el-tab-pane>
        <el-tab-pane label="教官荣誉" name="3">
          <teacherRY :userId="userId" :key="sid" v-if="tabindex==3"></teacherRY>
        </el-tab-pane>
      </el-tabs>-->
    </div>
  </div>
</template>
<script>
import * as teacherInfo from '@/api/teacher/teacherInfo';
import * as publiclist from '@/api/public';
import elSelectc from '@/components/elSelect';
import changerheader from '@/components/changeHeader';

import TreeSelect from '@/components/treeSelectt';
import gerenJL from './component/gerenJL';
import gerenxunLI from './component/gerenxunLI';
import teacherRY from './component/teacherRY';
// import UserList from './components/userList';
import elDragDialog from '@/directive/el-dragDialog';

export default {
  components: {
    elSelectc,

    TreeSelect,
    changerheader,
    gerenJL,
    gerenxunLI,
    teacherRY,
    // UserList,
  },
  directives: {
    elDragDialog,
  },

  data() {
    //身份证号码正则
    const checkIDCard = (rule, value, callback) => {
      const IDCardReg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      // const sfzhReg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
      if (value) {
        if (IDCardReg.test(value)) {
          callback();
        } else {
          callback(new Error('身份证号格式不正确'));
        }
      } else {
        callback(new Error('请输入身份证号'));
      }
    };
    return {
      createFlag: false,
      createId: JSON.parse(this.$store.state.User.infos).idCard,
      options: [],
      ziyuanLabel: [],
      activeName: '0',
      defaultCheckedKeys: [],

      dataForm: {},
      sid: +new Date(),
      ishowselect: false,
      userId: 0,
      temp: {
        id: 0,
        delivery: true,
        birthday: '', //生日
        typeDicId: null, //教官类别
        isFullTime: '', //专职或兼职
        workstatus: null, //现任或曾任
        sex: true, //性别
        jbDicId: null, //聘用级别
        lrfz: 1, //理论或实战
        jpDate: '', //拟解聘日期
        pinDate: '', //聘用时间
        photo: '', //头像
        name: '', //教官姓名
        idCard: '', //身份证
        skill: '', //特长
        jxcg: '', //科研和教学成果
        introduce: '', //个人简介
        cjgzjl: '', //从教工作经历
        curDeptId: '', //所在单位
        curDeptName: '',
        pxhd: '', //参加培训或活动
        rych: '', //立功受奖或荣誉称
        pinDeptId: 0, //聘用单位
        pinDeptName: '',
        phone: '', //联系电话
        jzDicId: null, //授课警种
        typeDicName: null,
        jzDicName: '',
        jbDicName: '',
        label: '',
        isHome: true,
        passStatus: 1,
        createId: this.$store.state.User.ids * 1,
        createName: JSON.parse(this.$store.state.User.infos).name,
        updateId: 0,
        levelId: 0,
      },
      curDeptName: '',
      rules: {
        name: [{ required: true, message: '名称不能为空', trigger: 'blur' }],
        idCard: [{ required: true, validator: checkIDCard, trigger: 'blur' }],
        jzDicId: [
          { required: true, message: '授课警种不能为空', trigger: 'blur' },
        ],
        typeDicId: [
          { required: true, message: '教官类别不能为空', trigger: 'blur' },
        ],
        jbDicId: [
          { required: true, message: '聘用级别不能为空', trigger: 'blur' },
        ],
        sex: [{ required: true, message: '身份证不能为空', trigger: 'blur' }],

        pinDeptId: [
          { required: true, message: '聘用单位不能为空', trigger: 'blur' },
        ],
        // pinDate: [
        //   { required: true, message: '聘用时间不能为空', trigger: 'blur' },
        // ],

        lrfz: [{ required: true, message: '选项不能为空', trigger: 'blur' }],
        // skill: [{ required: true, message: '特长不能为空', trigger: 'blur' }],
        label: [{ required: true, message: '标签不能为空', trigger: 'blur' }],
      },
      userListDialog: false,
      typeOne: 0, //传0过去只显示部门，不穿显示所有部门
      parentIdOne: JSON.parse(this.$store.state.User.infos).deptId, //只显示该部门以下的
      jbDicIdList: [],
      typeDicIdList: [],
      optionsjbDic: [],
      optionsType: [],
      handleUpdaterow: '',
      tabindex: 0,
      userId: this.$store.state.User.ids,
    };
  },
  created() {
    this.getTeacher();
    this.getPmiPic();
    this.getListbasejb();
    this.getListbaseType();
  },

  methods: {
    getTeacher() {
      teacherInfo.getById({ userid: this.userId }).then((res) => {
        this.handleUpdaterow = res.result;
        //调用组件父传子id

        if (
          this.handleUpdaterow.label !== '' &&
          this.handleUpdaterow.label !== null
        ) {
          this.ziyuanLabel = this.handleUpdaterow.label.split(',');
        }
        this.sid = +new Date(); //重新渲染组件
        this.temp = Object.assign({}, this.handleUpdaterow);
        let delive = {
          delivery: true,
        };
        this.temp = { ...this.temp, ...delive };

        if (this.temp.curDeptId != 0) {
          this.temp.delivery = true;
          this.defaultCheckedKeys = [
            { label: this.temp.curDeptName, id: this.temp.curDeptId },
          ];
          this.curDeptName = '';
        } else {
          this.temp.delivery = false;
          this.curDeptName = this.temp.curDeptName;
          this.defaultCheckedKeys = [{ label: '', id: 0 }];
        }

        this.$nextTick(() => {
          this.$refs['temp'].clearValidate();
        });
        if (this.handleUpdaterow.typeDicId) {
          this.typeDicIdList = this.handleUpdaterow.typeDicId.split(',');
          this.typeDicIdList = this.typeDicIdList.map(Number);
        }
        if (this.handleUpdaterow.jbDicId) {
          this.jbDicIdList = this.handleUpdaterow.jbDicId.split(',');
          this.jbDicIdList = this.jbDicIdList.map(Number);
        }

        this.ishowselect = true;
      });
    },

    btnjbDicId(val) {
      let codeData = val;
      let codeDataLength = codeData.length;
      let baseTypeNameList = [];

      for (let i = 0; i < codeDataLength; i++) {
        let value = codeData[i];
        this.optionsjbDic.map((item) => {
          if (item.id == value) {
            baseTypeNameList.push(item.name);
          }
        });
      }
      this.temp.jbDicId = this.jbDicIdList.join(',');
      this.temp.jbDicName = baseTypeNameList.join(',');
    },
    btnbaseType(val) {
      let codeData = val;
      let codeDataLength = codeData.length;
      let baseTypeNameList = [];
      for (let i = 0; i < codeDataLength; i++) {
        let value = codeData[i];
        this.optionsType.map((item) => {
          if (item.id == value) {
            baseTypeNameList.push(item.name);
          }
        });
      }
      this.temp.typeDicId = this.typeDicIdList.join(',');
      this.temp.typeDicName = baseTypeNameList.join(',');
    },
    getListbaseType() {
      let para = {
        NamespaceId: 7,
      };
      publiclist.getList(para).then((res) => {
        this.optionsType = res.result;
      });
    },
    getListbasejb() {
      let para = {
        NamespaceId: 9,
      };
      publiclist.getList(para).then((res) => {
        this.optionsjbDic = res.result;
      });
    },

    // 获取教官标签数据
    getPmiPic() {
      let para = {
        Page: 1,
        Limit: 20,
        NamespaceId: 64,
      };
      teacherInfo.getPmiDic(para).then((res) => {
        res.result.forEach((element) => {
          let obj = {
            value: element.name,
            label: element.name,
          };
          this.options.push(obj);
        });
      });
    },

    handleClick(tab, event) {
      if (tab.index == '0') {
        this.tabindex = 0;
      } else if (tab.index == '1') {
        this.tabindex = 1;
      } else if (tab.index == '2') {
        this.tabindex = 2;
      } else if (tab.index == '3') {
        this.tabindex = 3;
      } else if (tab.index == '4') {
        this.tabindex = 4;
      }
    },
    chilUpload(val) {
      this.temp.photo = val;
      // console.log(this.temp.photo);
    },
    // 选择类型返回
    selectDatatypeDicId(val) {
      // console.log(val);
      this.temp.typeDicId = val.value;
      this.temp.typeDicName = val.label;
    },
    // 选择类型返回
    selectDatajbDicId(val) {
      this.temp.jbDicId = val.value;
      this.temp.jbDicName = val.label;
    },
    selectDatalevelId(val) {
      this.temp.levelId = val.value;
    },
    list() {
      this.defaultCheckedKeys = [
        { id: this.temp.curDeptId, label: this.temp.curDeptName },
      ];
      // console.log(this.defaultCheckedKeys);
    },

    popoverHide(checkedIds, checkedData) {
      this.temp.curDeptId = checkedIds;
      this.temp.curDeptName = checkedData.label;
    },

    // 选择类型返回
    selectDatajzDicId(val) {
      this.temp.jzDicId = val.value;
      this.temp.jzDicName = val.label;
    },

    addOrEditData() {
      // 保存更新提交
      this.$refs['temp'].validate((valid) => {
        if (valid) {
          this.temp.label = this.ziyuanLabel.toString();

          this.temp.updateId = this.$store.state.User.ids * 1;
          teacherInfo.update(this.temp).then(() => {
            // console.log(this.temp);
            this.$notify({
              title: '成功',
              message: '更新成功',
              type: 'success',
              duration: 2000,
            });
          });
        }
      });
    },
  },
};
</script>
<style scoped>
/deep/.el-form-item__label {
  font-size: 12px;
  font-weight: normal !important;
}
.headera {
  width: 100px;
  height: 100px;
}
.el-row {
  margin-bottom: 20px;
  padding-top: 20px;
  /* height: 450px; */
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #fff;
  height: 760px;
  border-radius: 5px;
}
.bg-purple-light {
  background: #fff;
  height: 760px;
  border-radius: 5px;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
.button {
  margin-top: 50px;
  text-align: center;
}
.metter1 {
  background: #fff;
}
</style>
